import { apiFetch, ApiBaseUrl } from "./fetch";

const baseURL = appId => `${ApiBaseUrl}apps/${appId}/custom_devices`;

export default class ApiCustomDevices {
  static getCustomDevices(appId) {
    return apiFetch(baseURL(appId));
  }

  static getCustomDevice(appId, deviceId) {
    return apiFetch(`${baseURL(appId)}/${deviceId}`);
  }

  static updateCustomDevice(appId, deviceId, modelDevice) {
    return apiFetch(`${baseURL(appId)}/${deviceId}`, {
      method: "PATCH",
      body: { custom_device: modelDevice },
    });
  }

  static createCustomDevice(appId, modelDevice) {
    return apiFetch(`${baseURL(appId)}`, {
      method: "POST",
      body: { custom_device: modelDevice },
    });
  }

  static deleteCustomDevice(appId, deviceId) {
    return apiFetch(`${baseURL(appId)}/${deviceId}`, {
      method: "DELETE",
    });
  }
}
